import styled from 'styled-components';

export const Container = styled.div`
  min-height: calc(100vh - 60px);
  @media (max-width: 767px) {
    padding: 0px 0px 72px;
  }
  background-color: ${({ theme }) => theme.colors.background};
`;

export const Claims = styled.div`
  width: fit-content;
  padding: 50px 15px 0px;
  margin: auto;
  @media (max-width: 1200px) {
    max-width: 786px;
  }
  @media (max-width: 786px) {
    max-width: 390px;
  }
`;

export const Title = styled.div`
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0em;
  text-align: left;
  color: ${({ theme }) => theme.colors.mainDark};

  border-bottom: 1px solid ${({ theme }) => theme.colors.line};
  & span {
    display: block;
    width: fit-content;
    border-bottom: 2px solid ${({ theme }) => theme.colors.line};
  }
`;

export const ClaimsWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  padding: 30px 0px 60px;
  gap: 36px;
`;

export const ButtonWrap = styled.div`
  flex: 1;
  text-align: center;
  & p {
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: center;
    color: #000;
  }
`;
